module.exports = __webpack_public_path__ + "static/media/IMAGE_5-ARIEL_FARM_(GETTY)_desktop.342f4872.jpg";